import { API_CONFIG, getApiUrl } from "../config/apiconfig";

const MFA_METHOD_EMAIL = 1;
const MFA_METHOD_AUTHENTICATOR = 2;

const mfaRequest = async (endpointKey, options = {}, urlOverride = null) => {
  const url = urlOverride || getApiUrl(endpointKey);
  const response = await fetch(url, {
    headers: API_CONFIG.headers,
    ...options,
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getMfaSettings = (staffId) =>
  mfaRequest(
    null,
    {
      method: "GET",
    },
    `${getApiUrl("getMfaSettings")}?staffId=${encodeURIComponent(staffId)}`,
  );

/** True when user has a confirmed / enrolled authenticator app (not email-only MFA). */
export const isAuthenticatorEnrolled = (settingsOrResponse) => {
  const data = settingsOrResponse?.data ?? settingsOrResponse;
  if (!data || typeof data !== "object") return false;
  const confirmed =
    data.IsAuthenticatorConfirmed ?? data.isAuthenticatorConfirmed;
  const hasSecret = data.HasTotpSecret ?? data.hasTotpSecret;
  return confirmed === true || confirmed === 1 || hasSecret === true || hasSecret === 1;
};

export const setupAuthenticator = (staffId, emailId) =>
  mfaRequest("setupAuthenticator", {
    method: "POST",
    body: JSON.stringify({ StaffId: staffId, EmailId: emailId }),
  });

export const confirmAuthenticatorSetup = (staffId, otpCode) =>
  mfaRequest("confirmAuthenticatorSetup", {
    method: "POST",
    body: JSON.stringify({ StaffId: staffId, OtpCode: String(otpCode).trim() }),
  });

export const setPreferredMfaMethod = (staffId, emailId, preferredMfaMethod) =>
  mfaRequest("setPreferredMfaMethod", {
    method: "POST",
    body: JSON.stringify({
      StaffId: staffId,
      EmailId: emailId,
      PreferredMfaMethod: preferredMfaMethod,
    }),
  });

/** Admin recovery — clear authenticator so user can re-register (lost phone). */
export const resetAuthenticator = ({
  organizationId,
  staffId,
  createdBy,
}) =>
  mfaRequest("resetAuthenticator", {
    method: "POST",
    body: JSON.stringify({
      OrganizationId: organizationId,
      StaffId: staffId,
      CreatedBy: createdBy,
    }),
  });

export const switchMfaLoginMethod = (mfaSessionToken, targetMethod) =>
  mfaRequest("loginMfaSwitchMethod", {
    method: "POST",
    body: JSON.stringify({
      MfaSessionToken: mfaSessionToken,
      TargetMethod: targetMethod,
    }),
  });

export const buildQrCodeUrl = (otpAuthUri) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(otpAuthUri || "")}`;

export { MFA_METHOD_EMAIL, MFA_METHOD_AUTHENTICATOR };
